module.exports = {"510521001":"玉蟾街道","510521100":"福集镇","510521101":"嘉明镇","510521102":"喻寺镇","510521103":"得胜镇","510521105":"牛滩镇","510521106":"兆雅镇","510521107":"玄滩镇","510521108":"太伏镇","510521109":"云龙镇","510521110":"石桥镇","510521111":"毗卢镇","510521112":"奇峰镇","510521113":"潮河镇","510521114":"云锦镇","510521115":"立石镇","510521116":"百和镇","510521117":"天兴镇","510521118":"方洞镇","510521123":"海潮镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510521.json
// module id = 2419
// module chunks = 0